module.exports = "<c-select name=\"{{$ctrl.name}}\"\n  label=\"{{$ctrl.label}}\"\n  ng-model=\"$ctrl.ngModel\"\n  options=\"$ctrl.items\"\n  key-value=\"{{ !$ctrl.selectModel? 'codigo' : $ctrl.selectModel }}\"\n  ng-disabled=\"$ctrl.ngDisabled\"\n  ng-required=\"$ctrl.ngRequired\">\n</c-select>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/core/util/forms/selectParametro/selectParametro.html
// module id = 703
// module chunks = 0